import * as React from "react";
import WSProgressBar from "../../Workspace2/WSProgressBar";
// import FormGroup from "@mui/material/FormGroup";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
// import CardContent from "@mui/material/CardContent";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "../../Workspace2/sidebar.css";
import "./../..././../../../WorkSpace/SignUp2.css";
import { useHistory, useLocation, useParams } from "react-router";
import { motion } from "framer-motion";
import swal from "sweetalert";

import {
  CreateIr,
  CreatePresetCheck,
  GetAllCompanyData,
  // GetAllProject,
  GetCheckedIR,
  UpdateStepStatus,
  fetchCoa,
  getCheckData,
  getWorkspace,
  getBookClosurePresets,
  CreateBookClosurePresetCheck
} from "../ApiServices/apiHandler";
import { useEffect } from "react";
import { useState } from "react";
import "../../../WorkSpace/font.css";
// for accordian
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// end accordian
import moment from "moment";
import { getProjects } from "../../../Console/Component/services/apiHandler";
import WorkspaceHeader from "./WorkspaceHeader";
// import CircleIcon from '@mui/icons-material/Circle';
// import Checkbox from "@mui/material/Checkbox";

import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css"
import { ReactComponent as RightIcon } from "../../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as PervBtnIcon } from '../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import { ReactComponent as SearchIcon } from '../../../myfin_v2/assets/icons/search.svg'
import { ReactComponent as CircleCheckIcon } from '../../../myfin_v2/assets/icons/circle_check2.svg'


const label = { inputProps: { "aria-label": "Checkbox demo" } };

const ImportPresetV2 = (props) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const [allProject, setAllProject] = useState([]);
  const [selected, setSelected] = useState([]);
  // const [selectedAllPreset, setSelectedPreset] = useState([]);
  const [checkStatus, setCheckStatus] = useState(false);
  const [allCompany, setAllCompany] = useState([]);
  const [allCoaData, setAllCoa] = useState([]);
  const [workspace, setWorkspace] = useState("");
  const [singleWorkspace, setSingleWorkspace] = useState([]);
  const [bookClosurePresets, setBookClosurePresets] = useState([]);
  const [selectedBookClosurePresets, setSelectedBookClosurePresets] = useState([]);

  const { id } = useParams();
  let history = useHistory();
  const nextStep = async () => {
    try {
      const data = {
        steps: "step5",
        has_published: "draft",
        status: singleWorkspace.status,
        approver_id: singleWorkspace.approver_id,
        cancel_reason: singleWorkspace.cancel_reason,
      };
      const res = await UpdateStepStatus(id, data);
      if (res.status === 200) {
        history.push(`/inviteteammember/${id}`);
      }
    } catch (error) {
      console.log("error", error.message);
      return 0;
    }
  };
  const skipNext = async () => {
    history.push(`/inviteteammember/${id}`);
  };

  useEffect(() => {
    FetchProject();
    getIr();
    companyData();
    allCoa();
    getWorkspaceDetails();
    getSingleWorkspace();
    getBookClosurePreset();
  }, []);

  const companyData = async () => {
    try {
      const res = await GetAllCompanyData();
      if (res.status === 200) {
        setAllCompany(res.data.getAllCompanyData);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };
  const FetchProject = async () => {
    const res = await getProjects();
    if (res.status === 200) {
      setAllProject(res.data?.project);
    }
  };
  const getSingleWorkspace = async () => {
    const res = await getWorkspace(id);
    if (res.status === 200) {
      setSingleWorkspace(res.data?.getworkspace[0])
    }
  }

  const getBookClosurePreset = async () => {
    const res = await getBookClosurePresets();
    if (res.status === 200) {
      setBookClosurePresets(res.data?.presets)
    }
  }

  const handleSelectClick = async () => {
    try {
      if (allProject?.length > 0) {
        const newSelecteds = allProject.map((n) => n._id);
        setSelected(newSelecteds);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleSelectAllClick = async () => {
    try {
      if (allProject?.length > 0) {
        const newSelecteds = allProject.map((n) => n._id);
        setSelected(newSelecteds);
        // AllIr.push(Ir);
        let data = {
          w_id: id,
          all_Preset_checked: newSelecteds,
        };
        const res = await CreatePresetCheck(data);
        if (res.status === 200) {
          setCheckStatus(true);
          getIr();
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleSelectAllBookClosurePresets = async () => {
    try {
      if (bookClosurePresets?.length > 0) {
        const newSelecteds = bookClosurePresets.map((n) => n._id);
        setSelectedBookClosurePresets(newSelecteds);
        // AllIr.push(Ir);
        let data = {
          w_id: id,
          all_checked_bookclosure_presets: newSelecteds,
        };
        const res = await CreateBookClosurePresetCheck(data);
        if (res.status === 200) {
          setCheckStatus(true);
          getIr();
          swal("Success","Presets Imported Sucessfully","success");
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const getIr = async () => {
    try {
      const res = await GetCheckedIR(id);
      if (res.status === 200) {
        setSelected(res.data.getIR[0]?.all_preset_checked);
        setSelectedBookClosurePresets(res.data.getIR[0]?.all_checked_bookclosure_presets);
      }
    } catch (error) { }
  };

  const handleChangePreset = (field, e, id) => {
    const selectedIndex = selected?.indexOf(id);
    let Preset = [];
    if (selectedIndex === -1) {
      Preset = Preset.concat(selected, id);
    } else if (selectedIndex === 0) {
      Preset = Preset.concat(selected.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      Preset = Preset.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      Preset = Preset.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(Preset);
  };

  const handleBookClosurePreset = (field, e, id) => {
    const selectedIndex = selectedBookClosurePresets?.indexOf(id);
    let Preset = [];
    if (selectedIndex === -1) {
      Preset = Preset.concat(selectedBookClosurePresets, id);
    } else if (selectedIndex === 0) {
      Preset = Preset.concat(selectedBookClosurePresets.slice(1));
    } else if (selectedIndex === selectedBookClosurePresets?.length - 1) {
      Preset = Preset.concat(selectedBookClosurePresets.slice(0, -1));
    } else if (selectedIndex > 0) {
      Preset = Preset.concat(
        selectedBookClosurePresets.slice(0, selectedIndex),
        selectedBookClosurePresets.slice(selectedIndex + 1)
      );
    }
    setSelectedBookClosurePresets(Preset);
  };

  const allCoa = async () => {
    const res = await fetchCoa();
    if (res.status === 200) {
      setAllCoa(res.data.coa);
    }
  };

  const handleSelected = async () => {
    try {
      let data = {
        w_id: id,
        all_Preset_checked: selected,
      };
      const res = await CreatePresetCheck(data);
      if (res.status === 200) {
        setCheckStatus(true);
        getIr();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleBookClosureSelected = async () => {
    try {
      let data = {
        w_id: id,
        all_checked_bookclosure_presets: selectedBookClosurePresets,
      };
      const res = await CreateBookClosurePresetCheck(data);
      if (res.status === 200) {
        setCheckStatus(true);
        getIr();
        swal("Success","Presets Imported Sucessfully","success");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const CompanyName = (c_id) => {
    try {
      const nameCompany = allCompany.filter((adj) => adj._id === c_id);
      const result = nameCompany[0]?.company_name
        ? nameCompany[0]?.company_name
        : "unknown";
      return result;
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };

  const CoaName = (p_id) => {

    const nameOfCoa = allCoaData.filter((adj) => adj.project_id === p_id);
    const result = nameOfCoa[0]?.name ? `(${nameOfCoa[0]?.name})` : "";
    return result;
  }

  const getWorkspaceDetails = async () => {
    const res = await getCheckData(id);
    if (res.status === 200) {
      setWorkspace(res.data.getIR[0])
    }
  }

  const [activeTab, setActiveTab] = useState("Presets");
  const isDisabled = user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view";

  return (
    <>
      <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
        <div>
          <WSProgressBar activePage={5} id={id} />
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }} className={wsCreationcss.wsContentDiv}>
          <span className={`${wsCreationcss.wsContentHeading} mt-3 mb-1`}>
            Choose and import presets for faster configuration!
          </span>

          <div className={`${wsCreationcss.regContainer} mt-4`}>
            {/* Tabs on Top */}
            <div className={wsCreationcss.tabButtons} style={{ width:"240px" }}>
              <div
                className={`${wsCreationcss.tabButton} ${activeTab === "Presets" ? wsCreationcss.activeTab : ""}`}
                onClick={() => setActiveTab("Presets")}
              >
                {(selected?.length > 0 && checkStatus === true) || workspace?.all_preset_checked?.length > 0 ? (
                  <CircleCheckIcon className="mr-2 mb-1" />
                ) : null}
                Standalone Presets
              </div>
              <div
                className={`${wsCreationcss.tabButton} ${activeTab === "BookClosure" ? wsCreationcss.activeTab : ""}`}
                onClick={() => setActiveTab("BookClosure")}
              >
                {(selectedBookClosurePresets?.length > 0 && checkStatus === true) || workspace?.all_checked_bookclosure_presets?.length > 0 ? (
                  <CircleCheckIcon className="mr-2 mb-1" />
                ) : null}
                Book Closure Presets
              </div>
              <div
                className={`${wsCreationcss.tabButton} ${activeTab === "MIS" ? wsCreationcss.activeTab : ""}`}
                onClick={() => setActiveTab("MIS")}
              >
                MIS Presets
              </div>
            </div>

            {/* Content */}
            <div className={wsCreationcss.tabContent}>
              {activeTab === "Presets" && (
                <>
                  <div className={`${wsCreationcss.scrollArea} ml-2`}>
                    {allProject?.length > 0 &&
                      allProject.map((det) => {
                        const { _id } = det;
                        const selectedUser = selected?.includes(_id);
                        return (
                          <>
                            <div className="d-flex mb-2" key={_id} style={{ "align-items": "center" }}>
                              <input
                                style={{ "margin": "-20px 20px 0px 0px" }}
                                type="checkbox"
                                checked={selectedUser}
                                disabled={isDisabled}
                                onChange={(event) =>
                                  handleChangePreset("check_company", event, _id)
                                }
                              />
                              <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "90%", "margin-bottom": "15px" }}>
                                <div className={commoncss.dFlexClm}>
                                  <span className={wsCreationcss.wscLabel2}>
                                    {det.project_name || "unknown"} {CoaName(det._id)}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {CompanyName(det.company)}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ "gap": "14px" }}>
                                  <div className={wsCreationcss.wscCard1}>
                                    <span className={wsCreationcss.wscLabel4}>PY</span>
                                    <span className={wsCreationcss.wscLabel5}>{moment(det.previous_year).format("DD-MMM-YYYY")}</span>
                                  </div>
                                  <div className={wsCreationcss.wscCard1}>
                                    <span className={wsCreationcss.wscLabel4}>Created</span>
                                    <span className={wsCreationcss.wscLabel5}>{moment(det.createdAt).format("DD-MMM-YYYY")}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                  </div>

                  <hr />
                  <div className="d-flex">
                    <button
                      className={wsCreationcss.saveBtn}
                      onClick={handleSelected}
                      disabled={isDisabled}
                    >
                      Import selected Preset
                    </button>
                    <button
                      className={`${wsCreationcss.perviewBtn} ml-2`}
                      onClick={handleSelectAllClick}
                      disabled={isDisabled}
                    >
                      Import all Preset
                    </button>
                  </div>
                </>
              )}
              {activeTab === "BookClosure" && (
                <>
                  <div className={`${wsCreationcss.scrollArea} ml-2`}>
                    {bookClosurePresets?.length > 0 &&
                      bookClosurePresets.map((bookClosurePreset) => {
                        const { _id } = bookClosurePreset;
                        const selectedUser = selectedBookClosurePresets?.includes(_id);
                        return (
                          <>
                            <div className="d-flex mb-2" key={_id} style={{ "align-items": "center" }}>
                              <input
                                style={{ "margin": "-20px 20px 0px 0px" }}
                                type="checkbox"
                                checked={selectedUser}
                                disabled={isDisabled}
                                onChange={(event) =>
                                  handleBookClosurePreset("check_company", event, _id)
                                }
                              />
                              <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "90%", "margin-bottom": "15px" }}>
                                <div className={commoncss.dFlexClm}>
                                  <span className={wsCreationcss.wscLabel2}>
                                    {bookClosurePreset.name || "unknown"}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {CompanyName(bookClosurePreset.companyID)}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ "gap": "14px" }}>
                                  <div className={wsCreationcss.wscCard1}>
                                    <span className={wsCreationcss.wscLabel4}>Created on</span>
                                    <span className={wsCreationcss.wscLabel5}>{moment(bookClosurePreset.createdAt).format("DD-MMM-YYYY")}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                  </div>

                  <hr />
                  <div className="d-flex">
                    <button
                      className={wsCreationcss.saveBtn}
                      onClick={handleBookClosureSelected}
                      disabled={isDisabled}
                    >
                      Import selected Preset
                    </button>
                    <button
                      className={`${wsCreationcss.perviewBtn} ml-2`}
                      onClick={handleSelectAllBookClosurePresets}
                      disabled={isDisabled}
                    >
                      Import all Preset
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </motion.div>
        <div className={wsCreationcss.footerContainer}>
          <div>
            <button
              onClick={() => history.push(`/dashboard`)}
              className={wsCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
          </div>
          <div className={wsCreationcss.footerbtnContainer}>
            <span className={wsCreationcss.skipForNow} 
                  onClick={skipNext} >Skip for now</span>
            <button
              className={wsCreationcss.perviewBtn} onClick={() => history.push(`/importregister/${id}`)}
              type="button" style={{ "padding": "7px" }}><PervBtnIcon height={19} />Previous</button>

            <button onClick={nextStep} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>Next<RightIcon height={12} /></button>


          </div>
        </div>
      </div>
    </>
  );
};
export default ImportPresetV2;
